import { render, staticRenderFns } from "./review-table.vue?vue&type=template&id=12104448&scoped=true&"
import script from "./review-table.vue?vue&type=script&lang=js&"
export * from "./review-table.vue?vue&type=script&lang=js&"
import style0 from "./review-table.vue?vue&type=style&index=0&id=12104448&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12104448",
  null
  
)

export default component.exports